export const FETCH_HUBSPOT_FIELDS_SUCCESS = 'FETCH_HUBSPOT_FIELDS_SUCCESS'
export const FETCH_HUBSPOT_ATTRIBUTE_MAPPINGS_SUCCESS = 'FETCH_HUBSPOT_ATTRIBUTE_MAPPINGS_SUCCESS'
export const PATCH_HUBSPOT_ATTRIBUTE_MAPPINGS_ERROR = 'PATCH_HUBSPOT_ATTRIBUTE_MAPPINGS_ERROR'
export const PATCH_HUBSPOT_ATTRIBUTE_MAPPINGS_SUCCESS = 'PATCH_HUBSPOT_ATTRIBUTE_MAPPINGS_SUCCESS'
export const PATCH_HUBSPOT_ATTRIBUTE_MAPPINGS_START = 'PATCH_HUBSPOT_ATTRIBUTE_MAPPINGS_START'

export const FETCH_HUBSPOT_USERS_SEARCH_START = 'FETCH_HUBSPOT_USERS_SEARCH_START'
export const FETCH_HUBSPOT_USERS_SEARCH_SUCCESS = 'FETCH_HUBSPOT_USERS_SEARCH_SUCCESS'
export const FETCH_HUBSPOT_USERS_SEARCH_ERROR = 'FETCH_HUBSPOT_USERS_SEARCH_ERROR'

export const FETCH_HUBSPOT_USER_MAPPINGS_STARTED = 'FETCH_HUBSPOT_USER_MAPPINGS_STARTED'
export const FETCH_HUBSPOT_USER_MAPPINGS_SUCCESS = 'FETCH_HUBSPOT_USER_MAPPINGS_SUCCESS'
export const FETCH_HUBSPOT_USER_MAPPINGS_ERROR = 'FETCH_HUBSPOT_USER_MAPPINGS_ERROR'

export const PATCH_HUBSPOT_USER_MAPPINGS_FAILED = 'PATCH_HUBSPOT_USER_MAPPINGS_FAILED'
export const PATCH_HUBSPOT_USER_MAPPINGS_SUCCESS = 'PATCH_HUBSPOT_USER_MAPPINGS_SUCCESS'
export const PATCH_HUBSPOT_USER_MAPPINGS_START = 'PATCH_HUBSPOT_USER_MAPPINGS'

export const FETCH_HUBSPOT_BY_EMAIL_STARTED = 'FETCH_HUBSPOT_BY_EMAIL_STARTED'
export const FETCH_HUBSPOT_BY_EMAIL_FAILED = 'FETCH_HUBSPOT_BY_EMAIL_FAILED'
export const FETCH_HUBSPOT_BY_EMAIL_SUCCESS = 'FETCH_HUBSPOT_BY_EMAIL_SUCCESS'




// WEBPACK FOOTER //
// ./src/scripts/app/modules/hubspot/constants.js